import { ToggleTabsButton } from '../ToggleTabs';
export function PageTab(props) {
    const { path, children } = props;
    return <ToggleTabsButton tabKey={path}>{children}</ToggleTabsButton>;
}
